export * from "./isFlotiqStoreData";
